import React from "react"
import { useTranslation } from "react-i18next"
import { Grid, Typography, styled } from "@mui/material"

import IconSuccess from "assets/icons/success-green.svg"
import Button from "components/ui/Button"

type Props = {
  onView: () => void
}

const NpsSuccess = ({ onView }: Props) => {
  const { t } = useTranslation()

  return (
    <Container
      container
      direction="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <img src={IconSuccess} alt={t("features.nps.success.title")} />
      <Title variant="h6">{t("features.nps.success.title")}</Title>
      <Close onClick={onView}>{t("features.nps.success.view")}</Close>
    </Container>
  )
}

export default NpsSuccess

const Container = styled(Grid)`
  margin: 81px auto 54px auto;
  max-width: 275px;
  text-align: center;
`
const Title = styled(Typography)`
  font-size: 1.75rem;
  font-weight: 300;
  margin: 73px 0;
`
const Close = styled(Button)`
  background: rgba(0, 169, 149, 0.07);
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 400;
`
